import React, { useState } from 'react';
import './footer.scss';
import { Trans } from '@lingui/react';
// import { Modal } from 'antd';
import LocationMap from '../../GoogleMap';
import WorkingHours from '../../WorkingHours';
import Modals from '../../Modal';


const Footer = () => {
  const currentYear = new Date().getFullYear();
  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const [openModal, setOpenModal] = useState(null);

  return (
    <footer className='footer'>
      <nav className='margin-top'>
        <button onClick={() => setOpenModal("careers")} className="ant-btn css-dev-only-do-not-override-mc1tut ant-btn-default ant-btn-color-default ant-btn-variant-outlined booking"> <Trans id="career" /></button>
        <button onClick={() => setOpenModal("promotions")} className='ant-btn css-dev-only-do-not-override-mc1tut ant-btn-default ant-btn-color-default ant-btn-variant-outlined booking'> <Trans id="promotions" /></button>
      </nav>
      <Modals
        isOpen={openModal === "careers"}
        onClose={() => setOpenModal(null)}
        title="Open Positions"
        description="Currently we have a few openings available. Please contact HR for details."
      />

      <Modals
        isOpen={openModal === "promotions"}
        onClose={() => setOpenModal(null)}
        title="Current Promotions"
        description="20% discount on annual health check-ups until the end of the month."
      />
      <div className='d-flex'>
        <div>
          <p>
            <span class="contact-info__icon"><i class="ti-email"></i></span> <Trans id="email" />: medappointment81@gmail.com</p>
          <p><Trans id="phone" /></p>
          <p><Trans id="address" /></p>
        </div>
        <WorkingHours />
      </div>
      <LocationMap />
      <p>
        <a href="https://www.facebook.com/medicalcentreavak/?locale=hy_AM" bis_skin_checked="1"><i class="fab fa-facebook-f footer-social" ></i></a>
        <a
          href="https://www.instagram.com/avakmedicalcentre/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none' }}
        >
          <i className="fab fa-instagram footer-social"></i>
        </a>
        <a href="https://wa.me/37477240414" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-whatsapp footer-social"></i>
        </a>
      </p>
      <p>
        © {currentYear}{' '}
        <a
          href="https://www.facebook.com/BestCodingAcademy"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: "black" }}
        > {`Made with `}
          <i className="fa fa-heart" aria-hidden="true" style={{ color: '#00a458' }}></i>{' '}
          by Coding Academy
        </a>
      </p>
      <div id="back-top" style={{ display: 'block' }}>
        <a title="Go to Top" href="#" onClick={scrollToTop}>
          <i className="fas fa-level-up-alt go-up" aria-hidden="true"></i>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
